const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSpinnakerBlack(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "310 100 1300 350",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M600.29,206.83c-10.66-6.87-23.18-10.3-37.56-10.3s-26.29,3.49-36.02,10.44c-.94.67-1.75,1.48-2.65,2.2v-8.46h-33.37v217l38.11-11.3v-60.76c9.76,6.28,21.71,9.47,35.89,9.47s25.92-3.49,36.32-10.44c10.39-6.95,18.48-16.41,24.27-28.38,5.8-11.95,8.69-25.45,8.69-40.48s-2.94-28.9-8.83-40.82c-5.89-11.92-14.17-21.3-24.84-28.17ZM590.15,298.84c-2.51,6.92-6.36,12.41-11.55,16.48-5.21,4.09-11.89,6.12-20.04,6.12s-15.19-1.9-20.24-5.71c-5.05-3.8-8.7-9.14-10.91-16-2.24-6.86-3.35-14.84-3.35-23.93s1.11-17.06,3.35-23.92c2.22-6.86,5.77-12.19,10.64-16,4.87-3.8,11.23-5.71,19.11-5.71,8.44,0,15.37,2.06,20.81,6.19,5.43,4.12,9.44,9.65,12.02,16.55,2.6,6.91,3.89,14.54,3.89,22.88s-1.25,16.12-3.74,23.03Z",
    style: {
      fill: "#000",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 648.2,
    y: 142.29,
    width: 42.55,
    height: 37.55,
    rx: 18.78,
    ry: 18.78,
    style: {
      fill: "#000",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 650.56,
    y: 200.71,
    width: 37.83,
    height: 150.23,
    style: {
      fill: "#000",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M842.29,236.52c-1.77-6.62-4.71-13.01-8.83-19.12-4.12-6.12-9.89-11.18-17.32-15.17-7.43-3.98-17.03-5.98-28.8-5.98-14.74,0-26.97,3.19-36.66,9.6-4.56,3.01-8.54,6.51-12.02,10.41v-15.56h-33.67v150.23h38.4v-76.23c0-9.36,1.04-16.88,3.12-22.53,2.08-5.66,4.75-9.95,7.99-12.87,3.26-2.92,6.72-4.89,10.44-5.91,3.71-1.02,7.2-1.54,10.44-1.54,8.06,0,14.31,1.81,18.7,5.43,4.41,3.61,7.58,8.12,9.53,13.49,1.95,5.38,3.1,10.73,3.49,16.06.36,5.33.54,9.71.54,13.14v70.95h38.4v-84.3c0-2.5-.18-6.49-.54-11.95-.38-5.48-1.45-11.52-3.22-18.16Z",
    style: {
      fill: "#000",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M999.95,236.52c-1.77-6.62-4.71-13.01-8.83-19.12-4.12-6.12-9.89-11.18-17.32-15.17-7.43-3.98-17.03-5.98-28.8-5.98-14.74,0-26.97,3.19-36.66,9.6-4.56,3.01-8.54,6.51-12.02,10.41v-15.56h-33.67v150.23h38.4v-76.23c0-9.36,1.04-16.88,3.12-22.53,2.08-5.66,4.75-9.95,7.99-12.87,3.26-2.92,6.72-4.89,10.44-5.91,3.71-1.02,7.2-1.54,10.44-1.54,8.06,0,14.31,1.81,18.7,5.43,4.41,3.61,7.58,8.12,9.53,13.49,1.95,5.38,3.1,10.73,3.49,16.06.36,5.33.54,9.71.54,13.14v70.95h38.4v-84.3c0-2.5-.18-6.49-.54-11.95-.39-5.48-1.45-11.52-3.22-18.16Z",
    style: {
      fill: "#000",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1148.57,223.8c-5.3-10.02-13.09-17.06-23.39-21.15-10.28-4.08-22.07-6.12-35.32-6.12-18.09,0-32.38,3.89-42.86,11.69-10.46,7.79-17.61,17.9-21.42,30.32l34.23,10.86c2.4-6.86,6.61-11.64,12.66-14.33,6.02-2.68,11.82-4.03,17.39-4.03,10.01,0,17.14,2.08,21.42,6.26,3.33,3.26,5.33,8.03,6.06,14.2-6.38.95-12.47,1.86-18.17,2.7-9.74,1.44-18.45,2.94-26.15,4.52-7.7,1.57-14.31,3.38-19.88,5.42-8.08,2.98-14.49,6.66-19.27,11.06-4.78,4.4-8.24,9.49-10.37,15.24-2.13,5.75-3.19,12.1-3.19,19.05,0,8.34,1.92,15.97,5.77,22.89,3.85,6.91,9.51,12.42,16.96,16.55,7.47,4.12,16.57,6.19,27.35,6.19,12.97,0,23.71-2.25,32.2-6.75,6.7-3.56,13.03-8.93,19-15.98v18.55h33.1v-91.81c0-6.86-.27-13.08-.84-18.64-.57-5.56-2.31-11.13-5.28-16.69ZM1113.23,305.32c-1.02,2.13-2.94,4.78-5.77,7.92-2.83,3.16-6.63,5.95-11.41,8.41-4.78,2.47-10.64,3.69-17.59,3.69-4.37,0-8.13-.65-11.27-1.95-3.15-1.3-5.59-3.18-7.29-5.64-1.72-2.46-2.58-5.4-2.58-8.83,0-2.5.54-4.78,1.61-6.81,1.06-2.04,2.72-3.92,5-5.64,2.26-1.71,5.25-3.32,8.97-4.8,3.26-1.2,7-2.31,11.27-3.34,4.26-1.02,9.87-2.15,16.82-3.41,4.44-.8,9.87-1.73,16.06-2.78-.08,2.64-.21,5.58-.42,8.9-.32,5.42-1.45,10.18-3.4,14.26Z",
    style: {
      fill: "#000",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "1263.39 200.71 1302.06 200.71 1301.79 350.94 1263.39 350.94 1263.39 200.71",
    style: {
      fill: "#000",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1434.81,207.66c-11.03-7.41-24.43-11.13-40.21-11.13-14.83,0-27.96,3.36-39.35,10.09-11.41,6.72-20.35,16.17-26.85,28.31-6.5,12.15-9.74,26.43-9.74,42.85,0,15.02,3.31,28.35,9.94,39.98,6.63,11.64,15.8,20.77,27.55,27.41,11.73,6.63,25.29,9.95,40.69,9.95,14.47,0,27.78-3.8,39.98-11.41,12.2-7.61,21.12-18.27,26.78-31.99l-37.83-10.86c-2.78,6.12-6.81,10.81-12.11,14.05-5.27,3.25-11.64,4.87-19.06,4.87-11.77,0-20.69-3.82-26.76-11.47-4.45-5.59-7.23-12.92-8.43-21.92h105.44c1.59-18.17-.27-33.98-5.57-47.43-5.28-13.45-13.45-23.87-24.47-31.3ZM1396.28,229.36c11.05,0,19,3.36,23.86,10.09,3.2,4.42,5.32,10.73,6.41,18.85h-66.14c1.49-6.93,3.94-12.69,7.43-17.17,6.07-7.85,15.55-11.76,28.44-11.76Z",
    style: {
      fill: "#000",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1556.59,200.36c-4.55.33-8.97,1.12-13.22,2.37-4.28,1.26-8.22,2.99-11.82,5.22-4.73,2.78-8.72,6.31-11.98,10.57-1.54,2.03-2.91,4.18-4.17,6.42v-24.23h-33.4v150.23h38.13v-76.79c0-5.75.79-10.92,2.35-15.51,1.59-4.6,3.89-8.58,6.97-11.97,3.06-3.38,6.82-6.09,11.25-8.14,4.46-2.13,9.44-3.41,14.97-3.83,5.5-.41,10.35.02,14.54,1.32v-35.33c-4.55-.55-9.1-.67-13.63-.35Z",
    style: {
      fill: "#000",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M459.86,271.44c-6.91-3.94-16.07-7.39-27.47-10.36-11.68-2.97-20.38-5.38-26.08-7.23-5.7-1.85-9.46-3.66-11.26-5.43-1.81-1.76-2.72-3.94-2.72-6.54,0-4.36,2.11-7.69,6.33-10.01,4.22-2.32,9.8-3.24,16.76-2.78,7.14.56,12.8,2.46,16.97,5.7,4.17,3.25,6.58,7.65,7.23,13.21l38.66-6.95c-1.29-9.09-4.75-16.97-10.36-23.65-5.61-6.67-12.96-11.82-22.04-15.44-9.09-3.62-19.52-5.43-31.29-5.43s-22.69,1.93-31.64,5.77c-8.95,3.85-15.87,9.32-20.79,16.41-4.92,7.09-7.37,15.46-7.37,25.1,0,7.7,1.62,14.25,4.87,19.68,3.24,5.42,8.53,10.08,15.85,13.98,7.33,3.89,17.11,7.42,29.35,10.57,10.84,2.88,18.84,5.19,23.99,6.95,5.15,1.76,8.46,3.55,9.94,5.36,1.48,1.81,2.22,4.2,2.22,7.16,0,4.73-1.85,8.41-5.56,11.06-3.71,2.64-9,3.96-15.86,3.96-8.35,0-15.23-1.99-20.65-5.98-5.43-3.98-8.93-9.5-10.5-16.55l-38.66,5.84c2.5,15.67,9.57,27.79,21.2,36.37,11.64,8.58,26.92,12.87,45.83,12.87s35.05-4.4,46.17-13.21c11.12-8.81,16.69-20.91,16.69-36.3,0-7.79-1.58-14.44-4.73-19.96-3.16-5.52-8.19-10.24-15.09-14.19Z",
    style: {
      fill: "#000",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "1219.94 275.83 1165.69 350.94 1212.42 350.94 1243.66 306.59 1219.94 275.83",
    style: {
      fill: "#000",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1263.34,273.06h0s-52.03-72.35-52.03-72.35h-49.24l57.87,75.12,23.71,30.75,19.69-27.98h0c.58-.79.94-1.74.94-2.78s-.36-1.99-.94-2.77Z",
    style: {
      fill: "#000",
      strokeWidth: 0
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpinnakerBlack);
export default __webpack_public_path__ + "static/media/spinnaker-black.07637badcae26bac124ca9d205f1eb5f.svg";
export { ForwardRef as ReactComponent };